import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { PageHero } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";
import { IMAGES } from "../content/defaultContent";

export default function Expertise() {
  const { content } = useLanguage();
  const e = content.expertise;
  return (
    <div data-testid="expertise-page">
      <PageHero overline={e.hero.overline} title={e.hero.title} subtitle={e.hero.subtitle} image={IMAGES.cocoa} />

      <section className="bg-brand-beige py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="space-y-0">
            {e.steps.map((st, i) => (
              <Reveal
                key={i}
                variant="up"
                delay={i * 0.08}
                className="grid grid-cols-1 items-start gap-6 border-t border-brand-green/15 py-12 md:grid-cols-12"
              >
                <span className="font-mono text-lg text-brand-gold md:col-span-2">{st.num}</span>
                <h3 className="font-serif text-3xl text-brand-green md:col-span-4">{st.title}</h3>
                <p className="text-lg leading-relaxed text-brand-black/75 md:col-span-6">{st.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
